import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
class Navigation {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-nav',
            rootToggleAttr: 'rootToggle',
            childrenAttr: 'category',
            itemsAttr: 'items',
            scrollerAttr: 'scroller',
            groupAttr: 'data-nav-group',
            toggleAttr: 'toggle',
            labelAttr: 'label',
            closeAttr: 'close',
            levelAttr: 'data-nav-level',
            breakpoint: 1024
        };

        this.settings = Object.assign({}, defaults, options);

        this.$navigation = element;
        this.$navigationToggle = this.$navigation.querySelector('[' + this.settings.initAttr + '="' + this.settings.rootToggleAttr + '"]');
        this.$navigationToggles = this.$navigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.$body = document.querySelector('body');
        this.currentLevel = 1;
        this.breakpoint = window.matchMedia('(min-width: ' + this.settings.breakpoint + 'px)');

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$navigation.addEventListener('change', (e) => {
            const $element = e.target;

            if ($element === this.$navigationToggle) {
                this.currentLevel = 1;

                if (this.$navigationToggle.checked === true) {
                    disableBodyScroll(this.$navigation);
                    this.$body.classList.add('navigation--open');
                } else {
                    this.clearAllSubnavs();
                    clearAllBodyScrollLocks();
                    this.$body.classList.remove('navigation--open');
                }
            }

            if ($element.getAttribute(this.settings.initAttr) === this.settings.toggleAttr) {
                if ($element.checked === true) {
                    this.closeOthers($element);
                }
            }
        });

        // enter fires change event
        this.$navigation.addEventListener('keydown', (e) => {
            let isEnter = false;
            if ('key' in e) {
                isEnter = (e.key === 'Enter');
            } else {
                isEnter = (e.keyCode === 13);
            }

            if (isEnter) {
                const $element = e.target;
                if ($element.tagName.toLowerCase() === 'input' && $element.type === 'checkbox' && document.activeElement === $element) {
                    this.toggleInputChecked($element, !$element.checked);
                }
            }
        });

        // close navigation on outside click
        document.addEventListener('click', (e) => {
            const $navigation = e.target.closest('[data-nav="root"]');
            if (!$navigation && this.$navigationToggle.checked === true) {
                this.closeMainnav();
            }
        });

        // close navigation on ESC key
        document.addEventListener('keydown', (e) => {
            let isEscape = false;
            if ('key' in e) {
                isEscape = (e.key === 'Escape' || e.key === 'Esc');
            } else {
                isEscape = (e.keyCode === 27);
            }

            if (isEscape) {
                this.closeMainnav();
            }
        });

        // close navigation on resize
        window.addEventListener('resize', () => {
            this.closeMainnav();
        });
    }

    toggleInputChecked ($input, state = true) {
        $input.checked = state;

        const toggleInputCheckedEvent = new CustomEvent('change', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        $input.dispatchEvent(toggleInputCheckedEvent);
    }

    closeMainnav () {
        this.$navigationToggle.checked = false;
        this.currentLevel = 1;

        clearAllBodyScrollLocks();

        const navigationCloseEvent = new CustomEvent('change', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        this.$navigationToggle.dispatchEvent(navigationCloseEvent);
    }

    closeOthers ($currentToggle) {
        const $currentNav = $currentToggle.closest('[' + this.settings.initAttr + '="' + this.settings.itemsAttr + '"]');
        const $siblings = $currentNav.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');

        for (let i = 0; i < $siblings.length; i++) {
            if ($currentToggle !== $siblings[i]) {
                $siblings[i].checked = false;
            }
        }
    }

    clearAllSubnavs () {
        for (let i = 0; i < this.$navigationToggles.length; i++) {
            const $toggle = this.$navigationToggles[i];

            if ($toggle.checked === true) {
                $toggle.checked = false;
            }
        }
    }
}

export default Navigation;

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context === document) {
        const $navigation = document.querySelector('[data-nav="root"]');
        if ($navigation) {
            const navigationAPI = new Navigation($navigation);
            $navigation.API = navigationAPI;
        }
    }
});
